export enum PeriodRangeOptionEnum {
    CUSTOM_PERIOD = 0,
    LAST_12_PERIODS = 1,
    LAST_9_AND_NEXT_3_PERIODS = 2,
    LAST_6_AND_NEXT_6_PERIODS = 3,
    LAST_6_PERIODS = 4,
    LAST_4_AND_NEXT_2_PERIODS = 5,
    LAST_3_AND_NEXT_3_PERIODS = 6,
}
